export const objectValue = (dotNotation: string, obj: Record<string, any>) => dotNotation.split('.').reduce((o,i)=> o && o[i], obj)